export const DOCUMENT_TILE_CATEGORY_KEY = 'file' as const;
export const DOCUMENT_TILE_COMPONENT_KEY = 'documentTile' as const;
